import { useEffect, useRef } from "react";
import { animate, motion, useInView, useMotionValue, useTransform } from "framer-motion";

export const CountUp = ({ value, duration = 1.8, delay = 0, className = "" }) => {
  const target = Number(value);
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, amount: 0.6 });
  const mv = useMotionValue(0);
  const rounded = useTransform(mv, (v) => Math.round(v).toLocaleString());

  useEffect(() => {
    if (!inView || Number.isNaN(target)) return;
    const controls = animate(mv, target, { duration, delay, ease: [0.16, 1, 0.3, 1] });
    return () => controls.stop();
  }, [inView, target, duration, delay, mv]);

  if (Number.isNaN(target)) {
    return <span ref={ref} className={className}>{value}</span>;
  }
  return <motion.span ref={ref} className={className}>{rounded}</motion.span>;
};
